/* eslint-disable jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/anchor-has-content,jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UsersManage from 'mt-react-common/modules/users/services/UsersManage';
import DefaultSelect from 'components/Common/Inputs/DefaultSelect';
import { useLightForm } from 'utils/hooks/useLightForm';
import {
  getItemFromRefList,
  getValueFromRefDataModules
} from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import { addClientNotice } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';
import './index.css';

const UserBanManageModal = props => {
  const { modalIndex, userId, isOpen, onClose, onRefreshParentContent } = props;
  const [loading, setLoading] = useState(false);
  const modalId = `blockUser-${modalIndex}`;
  const lightForm = useLightForm({
    newStatus: null,
    reason: null,
    comment: null,
    hasCloseAccountTasks: 0,
    hasToCreateRefundsForAllExecutions: 0
  });

  const userStatuses = useSelector(state =>
    getItemFromRefList(state, 'userStatuses')
      .map((title, value) => ({
        value,
        title
      }))
      .filter(item => [1, 2].includes(item.value))
  );

  const statusLogCategories = useSelector(state =>
    getValueFromRefDataModules(state, 'kernel.statusLogCategories')
  ).filter(
    item =>
      item.accountStatus.toString() === lightForm.getFieldValue('newStatus')
  );

  const dispatch = useDispatch();

  useEffect(() => {
    // eslint-disable-next-line no-undef
    $(`#${modalId}`).modal(isOpen ? 'show' : 'hide');
  }, [isOpen]);

  const fetch = () => {
    setLoading(true);
    UsersManage.changeStatus(userId, lightForm.fields).then(responseModel => {
      // console.log(responseModel);
      if (responseModel && responseModel.status === 200) {
        onClose();
        onRefreshParentContent();
        dispatch(
          addClientNotice({
            type: 'success',
            message: `Статус пользователя успешно изменен. Пользователь: ${responseModel.data.accountUsername}, статус: ${responseModel.data.statusName}`
          })
        );
      } else if (responseModel && responseModel.status === 422) {
        lightForm.setErrors(responseModel.data);
      } else if (responseModel && responseModel.status === 403) {
        dispatch(
          addClientNotice({
            type: 'error',
            message: responseModel.data.message
          })
        );
      }
      setLoading(false);
    });
  };

  const errorDesc = fieldName => {
    const errorMessage = lightForm.getFirstFieldError(fieldName);
    if (errorMessage) {
      return <small className="help-block">{errorMessage}</small>;
    }
    return null;
  };

  return (
    <div
      className="modal fade user-ban-manage-modal"
      id={modalId}
      role="dialog"
      tabIndex="-1"
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-gray"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header text-center">
            <a
              aria-label="Close"
              className="close close-black"
              href={null}
              onClick={onClose}
            />
            <i className="fa fa-user-times modal-icon" />
            <h4 className="modal-title">
              <strong>Заблокировать пользователя id:{userId}</strong>
            </h4>
          </div>
          <div className="modal-body">
            <div className="panel-body">
              <div
                className={classNames('form-group', {
                  'has-error': lightForm.hasFieldError('newStatus')
                })}
              >
                <label className="control-label" htmlFor={'0'}>
                  Новое состояние
                </label>
                <DefaultSelect
                  placeholder="Выбирите статус"
                  value={lightForm.getFieldValue('newStatus')}
                  handleChangeValue={value =>
                    lightForm.setFieldValues({ newStatus: value, reason: null })
                  }
                  selectArrItems={userStatuses}
                  selectTitleNullValue={null}
                />
                {errorDesc('newStatus')}
              </div>
              <div
                className={classNames('form-group', {
                  'has-error': lightForm.hasFieldError('reason')
                })}
              >
                <label className="control-label" htmlFor={'0'}>
                  Причина
                </label>
                <DefaultSelect
                  placeholder="Выбирите причину"
                  value={lightForm.getFieldValue('reason')}
                  handleChangeValue={value =>
                    lightForm.setFieldValue('reason', value)
                  }
                  selectArrItems={statusLogCategories}
                  selectTitleNullValue={null}
                />
                {errorDesc('reason')}
              </div>
              <div
                className={classNames('form-group', {
                  'has-error': lightForm.hasFieldError('comment')
                })}
              >
                <label
                  htmlFor="blockTaskTextarea"
                  className="col-sm-2 control-label"
                >
                  Комментарий
                </label>
                <textarea
                  value={lightForm.getFieldValue('comment')}
                  onChange={e => {
                    lightForm.setFieldValue('comment', e.target.value);
                  }}
                  className="form-control"
                  rows="3"
                  id="blockTaskTextarea"
                />
                {errorDesc('comment')}
              </div>
              <div className={`form-group`}>
                <label htmlFor="form" className="control-label">
                  Дополнительно
                </label>
                <div className="control-group">
                  <div className="checkbox abc-checkbox abc-checkbox-primary">
                    <input
                      type="checkbox"
                      checked={
                        lightForm.getFieldValue('hasCloseAccountTasks') === 1
                      }
                      onChange={() =>
                        lightForm.setFieldValue(
                          'hasCloseAccountTasks',
                          lightForm.getFieldValue('hasCloseAccountTasks') === 1
                            ? 0
                            : 1
                        )
                      }
                      id={`hasCloseAccountTasks-user${userId}`}
                    />
                    <label htmlFor={`hasCloseAccountTasks-user${userId}`}>
                      Заблокировать все задачи пользователя
                    </label>
                  </div>
                  <div className="checkbox abc-checkbox abc-checkbox-primary">
                    <input
                      type="checkbox"
                      checked={
                        lightForm.getFieldValue(
                          'hasToCreateRefundsForAllExecutions'
                        ) === 1
                      }
                      onChange={() =>
                        lightForm.setFieldValue(
                          'hasToCreateRefundsForAllExecutions',
                          lightForm.getFieldValue(
                            'hasToCreateRefundsForAllExecutions'
                          ) === 1
                            ? 0
                            : 1
                        )
                      }
                      name={`complaint-type-1`}
                      id={`hasToCreateRefundsForAllExecutions-user${userId}`}
                    />
                    <label
                      htmlFor={`hasToCreateRefundsForAllExecutions-user${userId}`}
                    >
                      Возвратить средства заказчикам за все выполнения
                      пользователя
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <a
              className="btn btn-muted"
              data-dismiss="modal"
              href=""
              type="button"
            >
              Отмена
            </a>
            <a
              className={classNames('btn btn-success', {
                disabled: loading
              })}
              href=""
              type="button"
              onClick={e => {
                e.preventDefault();
                fetch();
              }}
            >
              Применить
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

UserBanManageModal.defaultProps = {
  isOpen: false,
  onRefreshParentContent: () => {}
};

UserBanManageModal.propTypes = {
  isOpen: PropTypes.bool,
  modalIndex: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  onRefreshParentContent: PropTypes.func
};

export default UserBanManageModal;



// WEBPACK FOOTER //
// ./src/components/Users/_actions/UserBanManageModal/index.js